import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Link } from 'foundations-components/transitional/components/Link';
import { H5 } from 'foundations-components/transitional/components/H5';
import { getSettingUrl } from '../../routing/utils/externalUrls';
import { getLanguageNameFromCode } from '../../utils/langUtils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TranslationLanguagesFilter(props) {
  const {
    options,
    value,
    articleLanguage
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const onChange = (lang, newChecked) => {
    if (newChecked) {
      props.onChange([...value, lang]);
    } else {
      const newValue = [...value];
      newValue.splice(newValue.indexOf(lang), 1);
      props.onChange(newValue);
    }
  };
  const onApply = () => {
    setIsOpen(false);
    props.onApply();
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.translationLanguagesFilter.linkPrefix"
    }), /*#__PURE__*/_jsx(Popover, {
      open: isOpen,
      placement: "bottom right",
      content: /*#__PURE__*/_jsxs(View, {
        maxInlineSize: "416px",
        padding: "600",
        children: [/*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.translationLanguagesFilter.popover.heading"
          })
        }), /*#__PURE__*/_jsx(Grid, {
          children: options.map(opt => {
            const checked = value.includes(opt.value);
            const isArticleLanguage = opt.value === articleLanguage;
            return /*#__PURE__*/_jsx(GridItem, {
              size: {
                xs: 6
              },
              paddingBlockEnd: "200",
              children: /*#__PURE__*/_jsx(Checkbox, {
                checked: opt.forceEnabled || checked,
                onChange: () => onChange(opt.value, !checked),
                readOnly: opt.forceEnabled || isArticleLanguage,
                children: getLanguageNameFromCode(opt.value)
              })
            }, opt.value);
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "knowledgeContentUI.translationLanguagesFilter.popover.addMoreInSettings_jsx",
            elements: {
              Link: linkProps => /*#__PURE__*/_jsx(Link, {
                href: getSettingUrl(''),
                children: linkProps.children
              })
            }
          })
        }), /*#__PURE__*/_jsxs(View, {
          marginBlockStart: "400",
          as: "div",
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: onApply,
            use: "tertiary",
            marginInlineEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.translationLanguagesFilter.popover.applyButton"
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: () => setIsOpen(false),
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.translationLanguagesFilter.popover.cancelButton"
            })
          })]
        })]
      }),
      children: /*#__PURE__*/_jsx(Button, {
        onClick: () => setIsOpen(!isOpen),
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.translationLanguagesFilter.linkText",
          options: {
            selectedCount: value.length,
            total: options.length
          }
        })
      })
    })]
  });
}